module.exports = __webpack_public_path__ + "img/feedback-svg.e73c06b1.svg";